
import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import CardUI from '../../../widgets/layout/CardUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import SpinnerUI from '../../../widgets/output/SpinnerUI.js'
import ModalFormUI from '../../../widgets/form/ModalFormUI.js'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI.js'
import NachReportRegisteredAmountUpdateModalSF from './NachReportRegisteredAmountUpdateModalSF.js'
import NachReportNACHFieldUpdateModalSF from './NachReportNACHFieldUpdateModalSF.js'
import NachReportInternalRemarksUpdateModalSF from './NachReportInternalRemarksUpdateModalSF.js'
import InputDateUI from '../../../widgets/form/InputDateUI.js'
import './NachReportPage.css'

// const formatClientResponse = (resp) => {
//   if (!resp) return '-'
//   if (resp === 'yes') return 'Yes'
//   if (resp === 'no') return 'No'
//   if (resp === 'pending') return 'Pending'
//   if (resp === 'no_response') return 'No Response'
//   return resp
// }

const formatAmountDisplay = (val) => {
  if (val === null || val === undefined || val === '' || val === '-' || val === 'NaN') {
    return '0.00'
  }
  return String(val)
}

export const formatDateTime = (dateVal) => {
  if (dateVal === null || dateVal === undefined || dateVal === '' || dateVal === '-' || dateVal === 'null' || dateVal === 'undefined') {
    return '-'
  }
  const s = String(dateVal).trim()
  if (!s || s === '-') return '-'

  const d = !isNaN(Number(s)) ? new Date(Number(s)) : new Date(s)
  if (!isNaN(d.getTime())) {
    const day = String(d.getDate()).padStart(2, '0')
    const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const month = MONTH_NAMES[d.getMonth()]
    const year = d.getFullYear()
    let hours = d.getHours()
    const minutes = String(d.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12
    const strHours = String(hours).padStart(2, '0')
    return `${day} ${month} ${year}, ${strHours}:${minutes} ${ampm}`
  }
  return s
}

const NachReportPageUI = ({
  context,
  loading,
  errorList,
  updateMode,
  onRegisteredAmountUpdateClick,
  onRegisteredAmountCancelClick,
  selectedAccountId,
  nachAccountList,
  yearMonth,
  yearMonthStr,
  nachDataPopulatedDateISO,
  presentationSentDateISO,
  onRefreshClick,
  onPopulateMonthlyDataClick,
  onPopulateMonthlyDataConfirm,
  onPopulateConfirmModalRequestClose,
  populateConfirmOpen,
  populatingMonthly,
  onTypeChange,
  onDownloadClick,
  downloadMode,
  onToggleIncluded,
  onDecisionModalOpen,
  selectedRecord,
  selectedCommRecord,
  onSendClientCommClick,
  sendCommConfirmOpen,
  sendingComm,
  onSendClientCommConfirm,
  onSendCommConfirmModalRequestClose,
  onSendEmailToInternalClick,
  sendEmailConfirmOpen,
  onSendEmailToInternalConfirm,
  onSendEmailConfirmModalRequestClose,
  submitted,
  successMsg,
  setErrorList,
  onNachRemarksUpdateClick,
  onNachDebitAmountUpdateClick,
  onNachIncludedUpdateClick,
  onDebitDateUpdateClick,
  debitDateUpdateMode,
  onDebitDateUpdateCancelClick,
  onDebitDateUpdateSubmit,
  debitDateValue,
  onDebitDateValueChange,
  debitDateValueError,
  debitDateSubmitting,
  debitDateModalErrorList,
  setDebitDateModalErrorList,
  nachFieldUpdateKind,
  nachFieldUpdateAccountId,
  onNachFieldUpdateCancelClick,
  onNachInternalRemarksUpdateClick,
  internalRemarksUpdateMode,
  internalRemarksAccountId,
  onInternalRemarksUpdateCancelClick,
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_nr' topnav='accounts'
    headerText='Nach Report' centered={false} page='nachReport'
    onTypeChange={onTypeChange} dimension='w1600'
  >
    {
      successMsg &&
      <div className='g_m_bottom_100'>
        <SuccessMessageUI successMsg={successMsg} />
      </div>
    }
    {
      errorList && errorList.length > 0 &&
      <div className='alm_error_box'>
        {errorList.map((error, index) => {
          let msg = error ? (typeof error === 'object' ? error.message || String(error) : error) : ''
          if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
            msg = 'Internal Server Error'
          }
          return msg ? <div key={index}>{msg}</div> : null
        })}
      </div>
    }
    {
      loading &&
      <div style={{ padding: '3.5rem 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <SpinnerComponentUI />
      </div>
    }
    {
      !loading && nachAccountList &&
      <div>
        <div className='su_fee'>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                <IconButtonUI
                  icon='icon-tasks'
                  onClick={onPopulateMonthlyDataClick}
                  label='Refresh Client List for the Month'
                  selected={populateConfirmOpen || populatingMonthly}
                />
                <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download NACH Presentation Excel' />
                <IconButtonUI icon='icon-envelope-o' onClick={onSendEmailToInternalClick} label='Send Email to Worldline' />
                {downloadMode && <SpinnerUI className='g_m_left_50' reserveSpace={false} show={downloadMode} />}
                {populatingMonthly && <SpinnerUI className='g_m_left_50' reserveSpace={false} show={populatingMonthly} />}
                <span className='g_m_left_100 g_large'><b>Nach Report{yearMonth ? `, ${yearMonth.monthName} ${yearMonth.year}` : ''}</b></span>
              </span>
            }
            right={
              <span className='g_flex_h g_flex_right g_m_right_100 nach-topbar-right'>
                <span className='nach-topbar-timelogs'>
                  <span className='nach-topbar-timelog'>
                    <span className='nach-timelog-label'>Data Populated:</span>
                    <span className='nach-timelog-value'>{formatDateTime(nachDataPopulatedDateISO)}</span>
                  </span>
                  <span className='nach-timelog-separator'>|</span>
                  <span className='nach-topbar-timelog'>
                    <span className='nach-timelog-label'>Presentation Sent:</span>
                    <span className='nach-timelog-value'>{formatDateTime(presentationSentDateISO)}</span>
                  </span>
                </span>
                <span className='nach-topbar-nav-divider' />
                <Link to={`/su/nachReport/${yearMonth && yearMonth.month == 1 ? yearMonth.year - 1 : (yearMonth ? yearMonth.year : '')}/${yearMonth && yearMonth.month == 1 ? 12 : (yearMonth ? yearMonth.month - 1 : '')}`}>Previous</Link>
                <span className='g_m_left_100' />
                <Link to={`/su/nachReport/${yearMonth && yearMonth.month == 12 ? yearMonth.year + 1 : (yearMonth ? yearMonth.year : '')}/${yearMonth && yearMonth.month == 12 ? 1 : (yearMonth ? yearMonth.month + 1 : '')}`}>Next</Link>
              </span>
            }
          />
        </div>

        {
          nachAccountList.length !== 0 &&
          <NachReportUI
            onRegisteredAmountUpdateClick={onRegisteredAmountUpdateClick}
            onNachRemarksUpdateClick={onNachRemarksUpdateClick}
            onNachDebitAmountUpdateClick={onNachDebitAmountUpdateClick}
            onNachIncludedUpdateClick={onNachIncludedUpdateClick}
            onDebitDateUpdateClick={onDebitDateUpdateClick}
            onNachInternalRemarksUpdateClick={onNachInternalRemarksUpdateClick}
            onToggleIncluded={onToggleIncluded}
            onDecisionModalOpen={onDecisionModalOpen}
            onSendClientCommClick={onSendClientCommClick}
            nachAccountList={nachAccountList}
          />
        }
        {
          nachAccountList.length === 0 && (!errorList || errorList.length === 0) &&
          <EmptyListUI
            context={context}
            createDisabledMessageLabel='No accounts'
          />
        }

      </div>
    }
    <NachReportRegisteredAmountUpdateModalSF
      context={context}
      updateMode={updateMode}
      onRegisteredAmountUpdateClick={onRegisteredAmountUpdateClick}
      selectedAccountId={selectedAccountId}
      onRefreshClick={onRefreshClick}
      onCancelClick={onRegisteredAmountCancelClick}
    />
    <NachReportNACHFieldUpdateModalSF
      context={context}
      isOpen={!!nachFieldUpdateKind}
      updateKind={nachFieldUpdateKind}
      selectedAccountId={nachFieldUpdateAccountId}
      selectedRecord={selectedRecord}
      yearMonth={yearMonthStr}
      onCancelClick={onNachFieldUpdateCancelClick}
      onRefreshClick={onRefreshClick}
    />
    <NachReportInternalRemarksUpdateModalSF
      context={context}
      updateMode={internalRemarksUpdateMode}
      selectedAccountId={internalRemarksAccountId}
      onCancelClick={onInternalRemarksUpdateCancelClick}
      onRefreshClick={onRefreshClick}
    />
    <ModalFormUI
      context={context}
      titleLabel='Update NACH Debit Date'
      buttonLabel='Update'
      cancelLabel='Cancel'
      isOpen={debitDateUpdateMode}
      onRequestClose={onDebitDateUpdateCancelClick}
      errorList={debitDateModalErrorList}
      setErrorList={setDebitDateModalErrorList}
      onSubmit={onDebitDateUpdateSubmit}
      busy={debitDateSubmitting}
    >
      <p className='g_m_bottom_100 g_muted g_small'>
        Select the NACH debit date to apply for all accounts{yearMonth ? ` in ${yearMonth.monthName} ${yearMonth.year}` : ''}:
      </p>
      <InputDateUI
        context={context}
        name='debitDate'
        label='Debit Date'
        required
        selectedDateISO={debitDateValue}
        onChange={onDebitDateValueChange}
        error={debitDateValueError}
      />
    </ModalFormUI>
    <ModalFormUI
      context={context}
      titleLabel='Refresh Monthly NACH Presentation Data'
      buttonLabel='Confirm & Refresh'
      cancelLabel='Cancel'
      isOpen={populateConfirmOpen}
      onRequestClose={onPopulateConfirmModalRequestClose}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onPopulateMonthlyDataConfirm}
      busy={populatingMonthly}
    >
      <p className='g_m_bottom_50'>
        Are you sure you want to refresh and populate the monthly NACH presentation data{yearMonth ? ` for ${yearMonth.monthName} ${yearMonth.year}` : ''}?
      </p>
      <div className='nach-modal-hint-box g_m_top_50'>
        <p className='g_small g_muted' style={{ margin: 0 }}>
          <b>Note:</b> This will recalculate and populate monthly NACH presentation records, dues, and surplus balances for all eligible accounts.
        </p>
      </div>
    </ModalFormUI>
    <ModalFormUI
      context={context}
      titleLabel='Send Email to Worldline'
      buttonLabel='Send to Worldline'
      cancelLabel='Cancel'
      isOpen={sendEmailConfirmOpen}
      onRequestClose={onSendEmailConfirmModalRequestClose}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSendEmailToInternalConfirm}
      busy={submitted}
    >
      <p className='g_m_bottom_50'>
        Are you sure you want to send the NACH transaction presentation email to Worldline?
      </p>
      <div className='nach-modal-hint-box g_m_top_50'>
        <p className='g_small g_muted' style={{ margin: 0 }}>
          <b>Tip:</b> You can download and review the prepared NACH presentation file (.xlsx) using the <b>Download NACH Presentation Excel</b> icon on the top bar before sending.
        </p>
      </div>
    </ModalFormUI>
    <ModalFormUI
      context={context}
      titleLabel='Send client communication'
      buttonLabel='Send'
      cancelLabel='Cancel'
      isOpen={sendCommConfirmOpen}
      onRequestClose={onSendCommConfirmModalRequestClose}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSendClientCommConfirm}
      busy={sendingComm}
    >
      <p className='g_m_bottom_100'>
        Send NACH presentation communication email?
      </p>
    </ModalFormUI>
  </SuperUserHomePageUI>

const NachReportUI = ({
  onRegisteredAmountUpdateClick,
  onNachRemarksUpdateClick,
  onNachDebitAmountUpdateClick,
  onNachIncludedUpdateClick,
  onDebitDateUpdateClick,
  onNachInternalRemarksUpdateClick,
  onToggleIncluded,
  onDecisionModalOpen,
  onSendClientCommClick,
  nachAccountList,
}) => {
  return (
    <CardUI className='nach-report-card'>
      <table className='table table_nach'>
        <thead>
          <tr>
            <th className='g_text_center' style={{ width: '42px' }}>S no.</th>
            <th className='g_text_left nach-col-client'>Client Name</th>
            <th className='g_text_left nach-col-urn'>URN</th>
            <th className='g_text_right'>Registered Amount</th>
            <th className='g_text_right'>To Collect</th>
            <th className='g_text_right'>Surplus Balance</th>
            <th className='g_text_right'>NACH Debit Amount</th>
            <th className='g_text_center'>
              Debit Date
              <span
                className='icon icon-pencil g_muted g_m_left_25'
                title='Edit Debit Date'
                style={{ cursor: 'pointer' }}
                onClick={onDebitDateUpdateClick}
              />
            </th>
            {/* <th className='g_text_center'>Client Response</th> */}
            <th className='g_text_center'>Put NACH?</th>
            <th className='g_text_left nach-col-remarks'>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {
            nachAccountList && nachAccountList.map((account, i) => {
              const isExcluded = account.included === false
              return (
                <tr key={account.accountId || i} className={isExcluded ? 'row_excluded' : ''}>
                  <td className='g_text_center'>{i + 1}</td>
                  <td className='g_text_left nach-col-client'>
                    <Link to={`/su/accounts/${account.accountId}/txns3`}>
                      {account.accountName || account.accountId}
                    </Link>
                  </td>
                  <td className='g_text_left nach-col-urn'>
                    {account.urn || '-'}
                  </td>
                  <td className='g_text_right g_no_wrap_2'>
                    {formatAmountDisplay(account.registeredNachAmount)}
                  </td>
                  <td className='g_text_right g_no_wrap_2'>
                    {formatAmountDisplay(account.amountDue)}
                  </td>
                  <td className='g_text_right g_no_wrap_2'>
                    {formatAmountDisplay(account.surplusBalance)}
                  </td>
                  <td className='g_text_right g_no_wrap_2'>
                    {formatAmountDisplay(account.debitAmount)}
                    <span
                      className='icon icon-pencil g_muted g_m_left_25'
                      title='Edit NACH Debit Amount'
                      style={{ cursor: 'pointer' }}
                      onClick={() => onNachDebitAmountUpdateClick && onNachDebitAmountUpdateClick(account)}
                      data-account-id={account.accountId}
                    />
                  </td>
                  <td className='g_text_center g_no_wrap_2'>{account.debitDate || '-'}</td>
                  {/* <td className='g_text_center g_no_wrap_2'>
                    {formatClientResponse(account.clientResponse)}
                    <span
                      className='icon icon-envelope-o g_muted g_m_left_25'
                      title='Send Client Communication'
                      style={{ cursor: 'pointer' }}
                      onClick={() => onSendClientCommClick && onSendClientCommClick(account)}
                    />
                  </td> */}
                  <td className='g_text_center g_no_wrap_2'>
                    {account.included !== false ? 'Yes' : 'No'}
                    <span
                      className='icon icon-pencil g_muted g_m_left_25'
                      title='Edit Put Nach?'
                      style={{ cursor: 'pointer' }}
                      onClick={() => onNachIncludedUpdateClick && onNachIncludedUpdateClick(account)}
                      data-account-id={account.accountId}
                    />
                  </td>
                  <td className='g_text_left nach-col-remarks'>
                    {account.remark || '-'}
                    <span
                      className='icon icon-pencil g_muted g_m_left_25'
                      title='Edit Remarks'
                      style={{ cursor: 'pointer' }}
                      onClick={() => onNachRemarksUpdateClick && onNachRemarksUpdateClick(account)}
                      data-account-id={account.accountId}
                    />
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </CardUI>
  )
}

export default NachReportPageUI
